/* tslint:disable */
/* eslint-disable */
/**
 * Doppio API
 * Microservice backend for ...
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum RoleEnum {
    Creditor = 'CREDITOR',
    Debtor = 'DEBTOR',
    Mortgagor = 'MORTGAGOR',
    Tenant = 'TENANT',
    Subtenant = 'SUBTENANT',
    Seller = 'SELLER',
    Pledger = 'PLEDGER',
    AccessoryDebtor = 'ACCESSORY_DEBTOR',
    Lender = 'LENDER',
    Borrower = 'BORROWER',
    Buyer = 'BUYER',
    Mediator = 'MEDIATOR',
    FutureSeller = 'FUTURE_SELLER',
    FutureBuyer = 'FUTURE_BUYER',
    Landlord = 'LANDLORD'
}

export function RoleEnumFromJSON(json: any): RoleEnum {
    return RoleEnumFromJSONTyped(json, false);
}

export function RoleEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleEnum {
    return json as RoleEnum;
}

export function RoleEnumToJSON(value?: RoleEnum | null): any {
    return value as any;
}

